// extracted by mini-css-extract-plugin
export default {"overlay":"Dropdown_overlay__BTNda","dropdown":"Dropdown_dropdown__FAXZ2","profile":"Dropdown_profile__yAkMo","links":"Dropdown_links__mQ5Z1","button":"Dropdown_button__l+yh6"};